import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentStep, triggerValidation } from "../../redux/profileFormSlice";
import { COLORS } from "../../constants/colors";

const NavigationButtons = ({ onSubmit, isSubmitting = false }) => {
  const dispatch = useDispatch();
  const { currentStep, ...formData } = useSelector((state) => state.profileForm);
  const isProfileComplete = useSelector((state) => state.auth.isProfileComplete);
  const [activeAction, setActiveAction] = useState(null); 
  const totalSteps = 6; 

  useEffect(() => {
    if (!isSubmitting) setActiveAction(null);
  }, [isSubmitting]);

  const validateStep = (step) => {
    const data = formData[`step${step}`] || {};
    const validations = {
      1: () => (data.currentSituation || []).length > 0,
      2: () => (data.interestReason || []).length > 0,
      3: () => ['firstName', 'lastName', 'country', 'state', 'city', 'email']
        .every(key => data[key]?.toString().trim()),
      4: () => ['education', 'status', 'experience', 'workYears']
        .every(key => data[key]?.toString().trim()),
      5: () => ['currentJob', 'industry']
        .every(key => (data[key] || '').toString().trim()),
    };
    return validations[step] ? validations[step]() : true;
  };

  const handleNext = () => {
    dispatch(triggerValidation(currentStep));
    setTimeout(() => {
      if (validateStep(currentStep) && currentStep < totalSteps) {
        dispatch(setCurrentStep(currentStep + 1));
      }
    }, 100);
  };

  const handlePrev = () => {
    if (currentStep > 1) dispatch(setCurrentStep(currentStep - 1));
  };

  const renderButtonContent = (label, actionType) =>
    isSubmitting && activeAction === actionType ? (
      <span className="inline-flex items-center gap-2">
        <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        {actionType === "submit" ? "Submitting..." : "Saving..."}
      </span>
    ) : (
      label
    );

  const baseBtn =
    "px-4 py-2 border border-gray-300 rounded-lg font-medium transition duration-200 disabled:cursor-not-allowed";

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mt-6">
      <button
        onClick={handlePrev}
        disabled={currentStep === 1}
        className={`${baseBtn} ${
          currentStep === 1
            ? "bg-gray-300 text-gray-400"
            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
        }`}
      >
        &lt; Previous
      </button>

      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
        <button
          onClick={() => {
            dispatch(triggerValidation(currentStep));
            setTimeout(() => {
              if (validateStep(currentStep)) {
                setActiveAction("save");
                onSubmit();
              }
            }, 100);
          }}
          disabled={isSubmitting}
          className={`${baseBtn} ${
            isSubmitting
              ? "bg-gray-300 text-gray-400"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {renderButtonContent(isProfileComplete ? "Update" : "Save and continue later", "save")}
        </button>

        <button
          onClick={currentStep === totalSteps ? () => {
            setActiveAction("submit");
            onSubmit();
          } : handleNext}
          disabled={isSubmitting}
          className={`${baseBtn} ${
            isSubmitting
              ? "bg-purple-300 text-white"
              : "text-white"
          } px-6`}
          style={!isSubmitting ? { backgroundColor: COLORS.purple } : {}}
        >
          {renderButtonContent(
            currentStep === totalSteps ? "Submit Profile" : "Next >",
            currentStep === totalSteps ? "submit" : null
          )}
        </button>
      </div>
    </div>
  );
};

export default NavigationButtons;
